import React, { useState } from "react";
import Configs from "../../Assets/editable-stuff/configurations.json";
import { Chat, Phone, Email, CheckCircle } from "@material-ui/icons";
import { Button } from "@material-ui/core";

const AboutMe = () => {
  const [heading] = useState("About Us");
  const [aboutDev] = useState(Configs.aboutDev);

  const features = [
    "Professional & Reliable Service",
    "5+ Years of Experience",
    "Serving New York Area",
    "Remote & On-Site Support"
  ];

  return (
    <section id="aboutme" className="about-section-modern">
      <div className="about-container">
        {/* Left Side - Visual */}
        <div className="about-visual">
          <div className="about-image-wrapper">
            <img
              src={require('../../Assets/img/Main Page/aboutLogo.png')}
              alt="NeedForGeeks Logo"
              className="about-main-image"
            />
            <div className="floating-badge badge-top">
              <span className="badge-icon">⭐</span>
              <span className="badge-text">5+ Years</span>
            </div>
            <div className="floating-badge badge-bottom">
              <span className="badge-icon">✓</span>
              <span className="badge-text">Trusted</span>
            </div>
          </div>
          <div className="about-pattern"></div>
        </div>

        {/* Right Side - Content */}
        <div className="about-content">
          <span className="about-label">Who We Are</span>
          <h2 className="about-title">{heading}</h2>

          <p className="about-description">{aboutDev}</p>

          <ul className="about-features">
            {features.map((feature, index) => (
              <li key={index} className="feature-item">
                <CheckCircle className="feature-icon" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>

          <div className="about-cta">
            <p className="cta-text">Ready to get started?</p>
            <div className="about-buttons">
              <Button
                className="about-btn-primary"
                variant="contained"
                startIcon={<Phone />}
                href={"tel: " + Configs.PhoneNumber}
              >
                Call Us
              </Button>
              <Button
                className="about-btn-secondary"
                variant="outlined"
                startIcon={<Chat />}
                href={"sms: " + Configs.PhoneNumber + "&body=" + Configs.aboutTemplate}
              >
                Text
              </Button>
              <Button
                className="about-btn-secondary"
                variant="outlined"
                startIcon={<Email />}
                href={"mailto: " + Configs.EmailAddress + "?subject=" + Configs.aboutSubject + "&body=" + Configs.aboutTemplate}
              >
                Email
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
